<template>
  <div v-if="image.url">
    <v-layout column class="py-4 px-4 pb-4">
      <v-card hover class="d-flex">
        <v-tooltip color="blue darken-4" top max-width="250">
          <template v-slot:activator="{ on, attrs }">
            <v-img
              :contain="false"
              :src="image.url"
              :aspect-ratio="'1'"
              :class="'image grey lighten-2'"
              :style="'cursor: pointer'"
              @click="$emit('click', image.index)"
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <span>{{image.title}}</span>
        </v-tooltip>
      </v-card>
      <strong>
        <p class="mt-2 mb-0 img-text img-title">{{image.title || ""}}</p>
      </strong>
      <p v-if="image.description" class="mt-2 mb-0 img-text img-description">
        {{image.description}}
      </p>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    image: { required: true, type: Object },
  },
};
</script>

<style scoped>
.image {
  cursor: pointer;
  width: 100%;
}

.img-text {
  color: black;
  text-overflow: ellipsis;
}

.img-description {
  overflow: hidden;
  text-align: justify;
}

.img-title {
  white-space: nowrap;
  overflow: hidden;
}

</style>
